import { Circle, Scissors, X } from "lucide-react";

const PREROLL = [2, 3, 5];
const t1 = (s) => `${Math.floor(s / 60)}:${(s % 60).toFixed(1).padStart(4, "0")}`;

/** Punch-in: re-record only the part you dragged across. The music starts a few seconds early; the original take is kept. */
export default function PunchBar({ sel, take, preroll, onPreroll, onPunch, onClear, disabled, tempo, snap, onSnap }) {
  if (!take) return null;
  if (!sel) {
    return (
      <p data-testid="punch-hint" className="flex items-center gap-2 rounded-2xl border border-white/[0.06] bg-black/20 px-4 py-2.5 text-[12px] text-white/55">
        <Scissors className="h-3.5 w-3.5 text-amber-200" /> Want to fix one line? Drag across it on the waveform above to re-record just that part.{tempo && snap ? " It snaps to the beat." : ""}
      </p>
    );
  }
  return (
    <div data-testid="punch-bar" className="flex flex-wrap items-center gap-3 rounded-2xl border border-amber-300/35 bg-amber-500/[0.08] px-4 py-3">
      <Scissors className="h-4 w-4 text-amber-200" />
      <div className="min-w-0 flex-1">
        <p data-testid="punch-range" className="font-display text-[14px] font-semibold">Fix {t1(sel.start)} – {t1(sel.end)} <span className="font-mono text-[11px] text-white/50">({(sel.end - sel.start).toFixed(1)} s) on {take.name}</span></p>
        <p className="text-[11px] text-white/55">You'll hear the song (and your take) from a little earlier, then sing the part. It stops on its own. Your original take stays.</p>
      </div>
      {tempo ? (
        <label className="flex cursor-pointer items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-white/60">
          <input type="checkbox" data-testid="punch-snap" checked={snap} onChange={(e) => onSnap(e.target.checked)} className="h-3.5 w-3.5 accent-amber-400" /> Snap to beats
        </label>
      ) : null}
      <label className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-white/60">Run-up
        <select data-testid="punch-preroll" value={preroll} onChange={(e) => onPreroll(Number(e.target.value))} className="rounded-lg border border-white/10 bg-black/40 px-2 py-1 text-[12px] text-white focus:outline-none">
          {PREROLL.map((s) => <option key={s} value={s}>{`${s} s`}</option>)}
        </select>
      </label>
      <button type="button" data-testid="punch-start" onClick={onPunch} disabled={disabled}
        className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-rose-500 to-red-600 px-5 py-2 font-display text-[13px] font-bold disabled:opacity-40">
        <Circle className="h-3.5 w-3.5 fill-white" /> Punch in
      </button>
      <button type="button" data-testid="punch-clear" onClick={onClear} aria-label="Clear selection" className="text-white/45 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
}
